import { useEffect } from "react";
import Banner from "../../component/home/banner/Banner.js";
import SliderChart from "../../component/home/sliderChart/SliderChart.js";
import Population from "../../component/home/population/Population.js";
import NewsVersion from "../../component/home/newsVersion/NewsVersion.js";
import Services from "../../component/home/services/Services.js";
import StatisticalCalendar from "../../component/home/statisticalCalendar/StatisticalCalendar.js";
import Poll from "../../component/home/poll/Poll.js";
import SlideNewVersion from "component/shared/slideNewVersion/SlideNewVersion.js";
import "./home.scss";
import { END_POINTS } from "constants/APIConstant.js";
import ReactGA from "react-ga4";

function Home() {
  useEffect(() => {
    const timeOut = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
    return () => {
      clearTimeout(timeOut);
    };
  }, []);

  ReactGA.initialize(END_POINTS.TRACKING_ID)

  useEffect(() => {
    // Send pageview with a custom path
    ReactGA.send({ hitType: "pageview", page: "/home", title: "Landing Page" });
  }, []);

  return (
    <div className="home">
      <Banner />
      <SliderChart />
      <Population />
      <div className="newsVersion">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 highlights">
              <NewsVersion />
            </div>
            <div className="col-lg-6 publication">
              <SlideNewVersion />
            </div>
          </div>
        </div>
      </div>
      <Services />
      <div className="container mb-4">
        <div className="row">
          <div className="col-12 col-lg-6">
            <StatisticalCalendar />
          </div>
          <div className="col-12 col-lg-6">
            <Poll />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
